import { CommerceService } from "@/services/commerce"

/**
 * If triggered more than once (custom type exists, error will be returned)
 *
 * Kept here to track progress and for future migrations.
 * Purpose to add custom field for customLineItem custom type and then store text information with other custom information
 */
export const mutationAddCustomFieldToCustomLineItemType = {
  async addCustomFieldToCustomLineItemType(parent, args, context, info) {
    const commerceApi = CommerceService.api()

    const key = "customCustomLineItemTypeKey"

    const customLineItemType = (await commerceApi.types().withKey({ key }).get().execute())?.body

    if (!customLineItemType) throw new Error("Custom type does not exist")

    const requestBody = {
      version: customLineItemType.version,
      actions: [
        {
          action: "addFieldDefinition",
          fieldDefinition: {
            type: { name: "String" },
            name: "additionalInformation",
            label: {
              "de-DE": "Weitere Informationen",
              "en-US": "Additional information",
            },
            required: false,
          },
        },
        {
          action: "addFieldDefinition",
          fieldDefinition: {
            type: { name: "Boolean" },
            name: "sendTechnicalManual",
            label: {
              "de-DE": "TM versenden",
              "en-US": "Send technical manual",
            },
            required: false,
          },
        },
        {
          action: "addFieldDefinition",
          fieldDefinition: {
            type: { name: "Boolean" },
            name: "sendProductText",
            label: {
              "de-DE": "Produkttext versenden",
              "en-US": "Send product text",
            },
            required: false,
          },
        },
        {
          action: "addFieldDefinition",
          fieldDefinition: {
            type: { name: "Number" },
            name: "discountPercent",
            label: {
              "de-DE": "Rabattprozentsatz",
              "en-US": "Discount percent",
            },
            required: false,
          },
        },
        {
          action: "addFieldDefinition",
          fieldDefinition: {
            type: { name: "Money" },
            name: "customPrice",
            label: {
              "de-DE": "Individueller Preis",
              "en-US": "Custom price",
            },
            required: false,
          },
        },
        {
          action: "addFieldDefinition",
          fieldDefinition: {
            type: { name: "Boolean" },
            name: "allowMultiple",
            label: {
              "de-DE": "Mehrere Einträge zulassen",
              "en-US": "Allow multiple entries",
            },
            required: false,
          },
        },
        {
          action: "addFieldDefinition",
          fieldDefinition: {
            type: { name: "String" },
            name: "additionalComment",
            label: {
              "de-DE": "Weitere Kommentar",
              "en-US": "Additional comment",
            },
            required: false,
          },
        },
        {
          action: "addFieldDefinition",
          fieldDefinition: {
            type: { name: "Number" },
            name: "position",
            label: {
              "de-DE": "Position",
              "en-US": "Position",
            },
            required: false,
          },
        },
        {
          action: "addFieldDefinition",
          fieldDefinition: {
            type: { name: "Number" },
            name: "skuPrice",
            label: {
              "de-DE": "SKU-Preis",
              "en-US": "Sku price",
            },
            required: false,
          },
        },
        {
          action: "addFieldDefinition",
          fieldDefinition: {
            type: { name: "Boolean" },
            name: "sendCertificateWithOffer",
            label: {
              "de-DE": "Zertifikate mit Angebot versenden",
              "en-US": "Send certificate with offer ",
            },
            required: false,
          },
        },
      ],
    }

    try {
      await commerceApi
        .types()
        .withKey({ key })
        .post({ body: JSON.stringify(requestBody) })
        .execute()

      return true
    } catch (error) {
      throw new Error(error)
    }
  },
}
